
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { ResellerPlanDetails } from '@/hooks/license/resellerPlans/types';

interface PlanBasicInfoProps {
  plan: ResellerPlanDetails;
  onUpdatePlan: (field: keyof ResellerPlanDetails, value: any) => void;
}

const PlanBasicInfo: React.FC<PlanBasicInfoProps> = ({ plan, onUpdatePlan }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium">Plan Name</label>
        <Input 
          value={plan.name} 
          onChange={(e) => onUpdatePlan('name', e.target.value)}
          placeholder="Enter plan name"
        />
      </div>
      
      <div>
        <label className="text-sm font-medium">Description</label>
        <Textarea 
          value={plan.description} 
          onChange={(e) => onUpdatePlan('description', e.target.value)}
          placeholder="Enter plan description"
          rows={3}
        />
      </div>
      
      <div>
        <label className="text-sm font-medium">Plan Type</label>
        <select 
          value={plan.planType} 
          onChange={(e) => onUpdatePlan('planType', e.target.value)}
          className="w-full p-2 border rounded-md"
        >
          <option value="reseller">Reseller</option>
          <option value="master">Master</option>
          <option value="standard">Standard</option>
        </select>
      </div>
      
      <div className="flex items-center space-x-2">
        <Switch 
          id="recommended" 
          checked={plan.recommended || false} 
          onCheckedChange={(checked) => onUpdatePlan('recommended', checked)}
        />
        <label htmlFor="recommended" className="text-sm font-medium">
          Mark as Recommended
        </label>
      </div>
      
      <div>
        <label className="text-sm font-medium">Badge Text (optional)</label>
        <Input 
          value={plan.badgeText || ''} 
          onChange={(e) => onUpdatePlan('badgeText', e.target.value)}
          placeholder="e.g. POPULAR, NEW, etc."
        />
        <p className="text-xs text-gray-500 mt-1">
          Text to show in a badge on the plan card
        </p>
      </div>
    </div>
  );
};

export default PlanBasicInfo;
